import { ReactComponent as IconCheckCircle } from './ic_check_circle.svg';
import { ReactComponent as IconCircle } from './ic_circle.svg';
import { ReactComponent as IconWhiteCircle } from './ic_white_circle.svg';

export { ReactComponent as ClipboardData } from './clipboard-data.svg';
export { ReactComponent as PlusCircle } from './plus-circle.svg';

export const studentProgress = [IconCheckCircle, IconCircle, IconWhiteCircle];
export { default as LeaderBoardLogo } from './leaderboard-header.png';
export { default as Ping } from './ping.png';
export { ReactComponent as expandCollapse } from './triangle-expand-collapse.svg';
